import React from "react";

function BankingFinancing() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Banking and Finance</b></h2>
            <div style={{color:"#5E5550"}}>
              <p>
              The scope of work in this area varies from one client to another.  Clients can be constituted from individual investors, large corporations or funds which will require help with their various financial transactions.  
              </p>
              <p>
              This area requires cooperation with professionals outside the legal field such as accountants, real estate developers when tailor made advise is needed from their respective professions.
              </p>
              <p>
              This area of law is under heavy scrutiny by relevant authorities such as the Central Bank.  Many steps have to be gone through to ensure that whatever the financial transaction it hand it does not violate any money laundering requirements and is  commercially viable for the client.
              </p>
              <p>
              New specialist areas are developing in this field such as real estate investment trust funds, and Shariah compliant funds.  A know-how and adaptability towards these specific areas is a key requirement.
              </p>
              <p>
              Nabeel Saeed’s past working experience includes working in the Central Bank meaning that this area of law is within his niche.
              </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default BankingFinancing;
